/**
 * 与消费系统相关的接口
 * 人脸支付统计报表接口http://rap2.10niu.cn/organization/repository/editor?id=26&mod=570&itf=3753
 */
import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import base from '@/config';
import qs from 'qs';

let req = {
	method: 'get'
};
let getWayRequest = (data, url) => {
	req.params = data;
	req.url = base.api.pos + '/consume/' + url;
	return requestByGateway(req);
};
const consume = {
	/**
	 * 判断是否有开通补助账户
	 * @param {*} data
	 */
	getOpenState(data) {
		return getWayRequest(data, 'IcStats/accountType');
	},
	// 获取活跃天数
	getActiveStats(data) {
		return getWayRequest(data, 'IcStats/getActiveStats');
	},
	/**
	 * 配置设置
	 * @param {*} data
	 */
	// 获取时段统计配置
	getTimeRange(data) {
		return getWayRequest(data, 'IcStats/getTimeStatsConfig');
	},
	// 设置消费时段
	setTimeRange(data) {
		return getWayRequest(data, 'IcStats/setStatsConfig');
	},
	// 获取统计范围
	getStatisticsRange(data) {
		return getWayRequest(data, 'IcStats/getUserStatsConfig');
	},
	// 设置统计范围
	setStatisticsRange(data) {
		return getWayRequest(data, 'IcStats/setStatsConfig');
	},
	// 设置统计范围（时段和统计范围）
	setConfig(data) {
		return requestByGateway({
			method: 'post',
			url: base.api.pos + '/consume/IcStats/setStatsConfig',
			headers: Object.assign(config.headers),
			data: qs.stringify(data)
		});
	},
	/**
	 * 搜索统计的记录
	 * @param {*} data
	 */
	// 按日期统计
	getDateRecord(data) {
		return getWayRequest(data, 'IcStats/getDateTimeStats');
	},
	// 按时段所搜统计记录
	getTimeRecord(data) {
		return getWayRequest(data, 'IcStats/getTimeIntervalStats');
	},
	// 按商户搜索统计记录
	getMerchantRecord(data) {
		return getWayRequest(data, 'IcStats/getMerchantStats');
	},
	// 按设备搜索统计数据
	getEqtRecord(data) {
		return getWayRequest(data, 'IcStats/getDevicesStats');
	},
	// 按用户搜索统计数据
	getUserRecords(data) {
		return getWayRequest(data, 'IcStats/getUserStats');
	},

	/**----------------------------------------------
	 * 现金统计的搜索
	 ------------------------------------------------*/
	//  按日期统计
	getCashDateRecord(data) {
		return getWayRequest(data, 'IcStats/getDateTimeStatsOnAmount');
	},
	//  按操作人员统计
	getOperatorRecord(data) {
		return getWayRequest(data, 'IcStats/getOperatorStatsOnAmount');
	},
	//  按人员统计
	getUserRecord(data) {
		return getWayRequest(data, 'IcStats/getUserStatsOnAmount');
	},
	/**----------------------------------------------
	 * 刷脸就餐api
	 * http://rap2.10niu.cn/organization/repository/editor?id=21&mod=363&itf=2451
	 ------------------------------------------------*/
	/**
	 * 根据学校ID获取套餐列表
	 */
	getPackageItems(params) {
		return requestByGateway({
			method: 'get',
			headers: config.headers,
			url: `${config.api.admin}/meal/v1/package_items`,
			params
		});
	},
	/**
	 * 根据套餐ID获取套餐详情
	 */
	getPackageDetail(params) {
		return requestByGateway({
			method: 'get',
			headers: config.headers,
			url: `${config.api.admin}/meal/v1/package_detail`,
			params
		});
	},
	/**
	 * 根据学校ID添加套餐
	 */
	packageCreate(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/meal/v1/package_create`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 根据套餐ID修改套餐
	 */
	packageUpdate(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/meal/v1/package_update`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 根据套餐ID删除套餐
	 */
	packageDelete(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/meal/v1/package_delete`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 根据套餐ID设置套餐就餐时间规则
	 */
	packageRuleSetting(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/meal/v1/package_rule_setting`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 根据套餐ID获取套餐就餐时间规则详情
	 */
	packageRuleDetail(params) {
		return requestByGateway({
			method: 'get',
			headers: config.headers,
			url: `${config.api.admin}/meal/v1/package_rule_detail`,
			params
		});
	},
	/**
	 * 根据套餐ID搜索订餐用户列表
	 */
	packageBookingsSearch(params) {
		return requestByGateway({
			method: 'get',
			headers: config.headers,
			url: `${config.api.admin}/meal/v1/package_bookings_search`,
			params
		});
	},
	/**
	 * 根据套餐ID和用户ID集合获取用户是否订餐
	 */
	packageIsBookings(params) {
		return requestByGateway({
			method: 'get',
			headers: config.headers,
			url: `${config.api.admin}/meal/v1/package_bookings_exists_by_userid`,
			params
		});
	},
	/**
	 * 根据订餐ID取消订餐
	 */
	packageBookingsUnbookings(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/meal/v1/package_bookings_unbookings`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 根据套餐ID和学生ID订餐
	 */
	packageBookings(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/meal/v1/package_bookings_bookings`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 根据套餐ID和学生ID集合批量订餐
	 */
	batchBookings(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/meal/v1/package_bookings_batch_bookings`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 就餐记录分页搜索
	 */
	recordSearch(params) {
		return requestByGateway({
			method: 'get',
			timeout: 1000 * 120,
			headers: config.headers,
			url: `${config.api.admin}/meal/v1/record_search`,
			params
		});
	},
	/**
	 * 未就餐记录分页搜索
	 */
	pendingRecordSearch(params) {
		return requestByGateway({
			method: 'get',
			headers: config.headers,
			url: `${config.api.admin}/meal/v1/pending_record_search`,
			params
		});
	},
	/**
	 * 根据学校ID获取就餐时间规则详情
	 */
	schoolRuleDetail(params) {
		return requestByGateway({
			method: 'get',
			headers: config.headers,
			url: `${config.api.admin}/meal/v1/school_rule_detail`,
			params
		});
	},
	/**
	 * 根据学校ID设置就餐时间规则
	 */
	schoolRuleSettingRule(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/meal/v1/school_rule_setting_rule`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 根据学生标识获取学生列表
	 */
	studentsByLabel(params) {
		return requestByGateway({
			method: 'get',
			headers: config.headers,
			url: `${config.api.admin}/meal/v1/get_students_by_label`,
			params
		});
	},
	/**
	 * 根据多个学生姓名或者手机号获取学生列表
	 */
	studentsByNames(params) {
		return requestByGateway({
			method: 'get',
			headers: config.headers,
			url: `${config.api.admin}/meal/v1/get_students_by_names`,
			params
		});
	},
	/**
	 * 根据学校ID获取年级就餐规则详情
	 */
	gradeRuleDetail(params) {
		return requestByGateway({
			method: 'get',
			headers: config.headers,
			url: `${config.api.admin}/meal/v1/package_grade_rule_detail`,
			params
		});
	},
	/**
	 * 根据学校ID设置年级就餐规则
	 */
	gradeRuleSetting(data) {
		return requestByGateway({
			method: 'post',
			headers: config.headers,
			url: `${config.api.admin}/meal/v1/package_grade_rule_setting`,
			data: qs.stringify(data)
		});
	},
	/**
	 * 根据学校id获取年级规则状态
	 */
	gradeRuleStatus(params) {
		return requestByGateway({
			method: 'get',
			headers: config.headers,
			url: `${config.api.admin}/meal/v1/package_grade_rule_status`,
			params
		});
	},
	/**
	 * 根据学校id设置年级规则状态
	 */
	gradeRuleStatusSetting(data) {
		return requestByGateway({
			method: 'post',
			headers: config.headers,
			url: `${config.api.admin}/meal/v1/package_grade_rule_status_setting`,
			data: qs.stringify(data)
		});
	},
	/**
	 * 根据学校id获取设备
	 */
	deviceSearch(params) {
		return requestByGateway({
			method: 'get',
			headers: config.headers,
			url: `${config.api.admin}/device/v1/device_search`,
			params
		});
	},
	/**
	 * 按日期就餐统计报表
	 */
	statisticsDaily(params) {
		return requestByGateway({
			method: 'get',
			timeout: 1000 * 60,
			headers: config.headers,
			url: `${config.api.admin}/meal/v1/statistics_daily`,
			params
		});
	},
	/**
	 * 按餐次就餐统计报表
	 */
	statisticsMeals(params) {
		return requestByGateway({
			method: 'get',
			timeout: 1000 * 60,
			headers: config.headers,
			url: `${config.api.admin}/meal/v1/statistics_meals`,
			params
		});
	},
	/**
	 * 批量取消订餐
	 */
	batchCancelBookings(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/meal/v1/package_bookings_batch_unbookings`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	/**
	 * 微信代扣_自助售货机_退款列表
	 */
	refundList(params) {
		return requestByGateway({
			method: 'get',
			headers: config.headers,
			url: `${config.api.pos}/machine/refund_list`,
			params
		});
	},
	/**
	 * 微信代扣_自助售货机_退款详情
	 */
	refundInfo(params) {
		return requestByGateway({
			method: 'get',
			headers: config.headers,
			url: `${config.api.pos}/machine/refund_info`,
			params
		});
	},
	/* 
	 人脸支付活跃天数统计 
	 */
	getActiveStatsV2(data) {
		return getWayRequest(data, 'IcStats/getActiveStatsV2');
	},
	/*
	 人脸支付按日期统计_资金 
	 */
	getDateTimeStatsOnAmountV2(data) {
		return getWayRequest(data, 'IcStats/getDateTimeStatsOnAmountV2');
	},
	/* 
	 人脸支付按用户统计接口_资金
	 */
	getUserStatsOnAmountV2(data) {
		return getWayRequest(data, 'IcStats/getUserStatsOnAmountV2');
	}
};
export default consume;
